import Boboloading from '@/components/Boboloading';
import { deviceId, getStage, getToken, vesion } from '@/utils/func';
import { getTransId, PLATFORMTYPE } from '@/utils/userAgent';
import { Toast } from 'antd-mobile';

import { AppUtil, isApp } from './utils/appHooks';

// 与后端约定的响应数据格式
interface ResponseStructure {
  data: any;
  code: number;
  message: string;
}

/**
 * 后端某些接口会出现另一种格式
 * 这里是临时的类型后续可能会移除
 */
interface ResponseStructure2 {
  timestamp: string;
  status: number;
  error: string;
  message: string;
  path: string;
}

export const networkError = (status: number) => {
  switch (status) {
    case 100:
      Toast.show({ content: '请继续请求', icon: 'error' });
      break;
    case 101:
      Toast.show({ content: '请升级协议', icon: 'fail' });
      break;
    case 400:
      Toast.show({ content: '请求错误，服务器未能理解请求', icon: 'fail' });
      break;
    case 401:
      Toast.show({ content: '用户没有权限或登陆超时', icon: 'fail' });
      break;
    case 403:
      Toast.show({ content: '系统维护中', icon: 'fail' });
      break;
    case 404:
      Toast.show({ content: '请求的接口不存在', icon: 'fail' });
      break;
    case 405:
      Toast.show({ content: '请求指定的方法不被允许', icon: 'fail' });
      break;
    case 408:
      Toast.show({ content: '请求超时', icon: 'fail' }); // 408
      break;
    case 500:
      Toast.show({ content: '网络错误', icon: 'fail' });
      break;
    case 502:
      Toast.show({ content: '网关错误', icon: 'fail' }); // 502
      break;
    case 503:
      Toast.show({ content: '服务器开小差了', icon: 'fail' }); // unavaliable是有效的意思
      break;
    case 504:
      Toast.show({ content: '网关超时', icon: 'fail' }); // 504
      break;
    default:
      Toast.show({ content: '请求错误', icon: 'fail' });
      break;
  }
};

const resTypeConversion = (res: ResponseStructure | ResponseStructure2) => {
  if ('code' in res) return res;

  return {
    code: res.status,
    message: res.message,
    data: null,
  };
};

// 当前请求个数
let reqLoadingNum: number = 0;

/**
 * @name 拦截器
 * @doc https://umijs.org/docs/max/request#配置
 */
export const requestConfig = {
  timeout: 1000 * 100, //请求时间
  errorConfig: {
    // 响应码本身就异常会走这里
    errorHandler(err: any) {
      if (err?.response?.status >= 400) {
        networkError(err?.response?.status);
      } else {
        Toast.show({
          content: err?.response?.data?.message ?? '请求失败！',
          duration: 1000,
        });
      }
    },
  },
  // 请求拦截器
  requestInterceptors: [
    async (config: any) => {
      const headers = config.headers;
      const token = getToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      const stage = getStage();
      if (stage) {
        headers.STAGE = stage;
      }
      const headeConfig = {
        'MSG-ID': getTransId(),
        'PLATFORM-TYPE': `${PLATFORMTYPE()}`,
        'DEVICE-ID': deviceId() || '',
        'APP-VERSION': vesion() || '',
      };
      reqLoadingNum = reqLoadingNum + 1;
      if (
        reqLoadingNum === 1 &&
        !headers.showLoading &&
        !config.url.includes('lottery-activitys') &&
        !config.url.includes('dragon-crystals/exchangeable-count')
      ) {
        Toast.show({
          icon: <Boboloading />,
          maskClickable: false,
          duration: 0,
        });
      }
      return { ...config, headers: { ...headers, ...headeConfig } };
    },
  ],

  /**
   * 响应拦截器
   *
   * BUG: umi默认消费了响应拦截器的data属性
   * 这会导致响应拦截器中的return值和接口返回值不一致的问题，需要额外注意
   */
  responseInterceptors: [
    async (response: any) => {
      let data: any;
      data = resTypeConversion(response.data as any);
      reqLoadingNum = reqLoadingNum - 1;
      if (data?.code && data?.code !== 0) {
        if (data.code === 401) {
          if (isApp()) {
            AppUtil.login();
          }
        }
        Toast.clear();
        Toast.show({ content: data.message ?? '请求失败！', duration: 1000 });
        // errorMapCb[data.code]?.();
        // throw new Error(data.code.toString());
      }
      if (reqLoadingNum <= 0) {
        Toast.clear();
      }
      // 注意: 这里返回res.data也就是ResponseStructure，umi会再返回一层data直接拿到真实数据T
      return response;
    },
  ],
};
